import _403_dp from './pages/_403_dp'
import _404_dp from './pages/_404_dp'
import _500_dp from './pages/_500_dp'
import _uknown_error_dp from './pages/_uknown_error_dp'
import oneDoc_403_dp from './oneDocPages/_403_dp'
import oneDoc_404_dp from './oneDocPages/_404_dp'
import oneDoc_500_dp from './oneDocPages/_500_dp'
import oneDoc_uknown_error_dp from './oneDocPages/_uknown_error_dp'
import responsive_403_dp from './responsivePages/_403_dp'
import responsive_404_dp from './responsivePages/_404_dp'
import responsive_500_dp from './responsivePages/_500_dp'
import responsive_uknown_error_dp from './responsivePages/_uknown_error_dp'
import type { PageJson } from '@wix/thunderbolt-becky-types'

type PagesMap = {
	[id: string]: (externalBaseUrl: string) => PageJson
}

const classicErrorPagesMap = ({
	_403_dp,
	_404_dp,
	_500_dp,
	_uknown_error_dp,
} as any) as PagesMap

const oneDocErrorPagesMap = ({
	_403_dp: oneDoc_403_dp,
	_404_dp: oneDoc_404_dp,
	_500_dp: oneDoc_500_dp,
	_uknown_error_dp: oneDoc_uknown_error_dp,
} as any) as PagesMap

const responsiveErrorPagesMap = ({
	_403_dp: responsive_403_dp,
	_404_dp: responsive_404_dp,
	_500_dp: responsive_500_dp,
	_uknown_error_dp: responsive_uknown_error_dp,
} as any) as PagesMap

const getPagesJson = ({
	errorPageId,
	isResponsiveSite,
	externalBaseUrl,
	isOneDocMigrated,
}: {
	errorPageId: string
	isResponsiveSite: boolean
	externalBaseUrl: string
	isOneDocMigrated: boolean
}): PageJson | null => {
	const errorPagesMap = isResponsiveSite
		? responsiveErrorPagesMap
		: isOneDocMigrated
			? oneDocErrorPagesMap
			: classicErrorPagesMap
	const errorPageStructureResolver = errorPagesMap[errorPageId]

	return errorPageStructureResolver?.(externalBaseUrl) || null
}

export default getPagesJson
